import React from 'react';
import ReactTypingEffect from 'react-typing-effect';

import img from 'assets/images/MainLanding/img.svg';

const typingTextSettings = {
  text: ['Staffing Firms', 'Gig Workers', 'Corporate Talent Acquisition'],
  speed: 50,
  eraseDelay: 2000,
  typingDelay: 1000,
  cursorClassName: 'typing-cursor',
};

export default function PlatformSection() {
  return (
    <section className="platform-section bg-text-section">
      <span className="bg-text">MYBASEPAY</span>

      <div className="container section-content">
        <div className="wrapper">
          <div className="content">
            <div className="title">
              You Hire. <span>We enable</span>
            </div>

            <p>
              myBasePay is a contingent workforce
              <br />
              platform that puts your talent first
            </p>

            <p className="solutions-block">
              <span>Turnkey solutions for:</span>
              <strong className="solutions-animation">
                <ReactTypingEffect {...typingTextSettings} />
              </strong>
            </p>

            <a
              href="mailto:sales@mybasepay.com"
              className="btn primary-btn size-lg"
            >
              <span>SCHEDULE A DEMO</span>
            </a>
          </div>

          <div className="img-wrapper">
            <img src={img} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
}
